import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../site/Motion";
import { INDUSTRIES } from "../../lib/industries";

export const IndustriesStrip = () => (
  <section data-testid="home-industries-strip" className="bg-white py-24 md:py-28">
    <div className="container-x">
      <div className="mb-12 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <SectionHead eyebrow="Industries we serve" title={<>Six industries. <span className="text-[#0a6cff]">One supplier.</span></>} />
        <Link to="/industries" data-testid="home-industries-link" className="btn-electric self-start md:self-end">All industries <ArrowRight className="h-4 w-4" /></Link>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-6">
        {INDUSTRIES.map((ind, i) => {
          const Icon = ind.icon;
          return (
            <Reveal key={ind.key} delay={i * 0.06}>
              <Link
                to="/industries"
                data-testid={`home-industry-${ind.key}`}
                className="clip-corner-sm group relative flex aspect-[3/4] flex-col justify-between overflow-hidden bg-[#07090e] p-4"
              >
                <img src={ind.img} alt={`Rubber parts for ${ind.name}`} loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-70 transition-[transform,opacity] duration-700 group-hover:scale-[1.08] group-hover:opacity-90" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#07090e] via-[#07090e]/40 to-transparent" />
                <span className="relative z-10 flex h-10 w-10 items-center justify-center bg-white text-[#0a6cff] transition-[background-color,color] duration-300 group-hover:bg-[#0a6cff] group-hover:text-white">
                  <Icon className="h-5 w-5" strokeWidth={1.6} />
                </span>
                <span className="font-display relative z-10 text-xl font-extrabold uppercase leading-[0.95] text-white md:text-2xl">{ind.name}</span>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
